exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home{background-color:#fcfcfc}.home .content,.home .sidebar{display:inline-block}.home .sidebar{position:fixed;float:left;width:220px}.home .content{margin-left:230px;width:calc(100% - 255px);padding-left:25px}.home .check-contributor,.home .contributor-button{float:right}.home .contributor-button{background-color:#90dc19;width:175px;height:45px;border:0;border-radius:30px;font-family:Graphik-Regular;color:#fff;font-size:13px;outline:0;box-shadow:0 3px 8px rgba(0,0,0,.21)}.home .contributor-button:hover{font-weight:700;background-color:#7fd100}.home .check-contributor{height:35px;margin-top:10px;margin-right:11px}.home .check-contributor p{margin-top:8px;font-size:12px;font-family:Graphik;color:#787878}.home .check-contributor p b{color:#000;cursor:pointer}.home.geo .check-contributor p,.home.geo .contributor-button{font-family:Georgian-Regular}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/home.scss
// module id = 553
// module chunks = 0